import React, { useState } from "react";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import Button from "../../atoms/button/button";
import TitleSection from "../../molecules/title-section";

// Styles //
import "./sectionVideoMpc.scss";
import "../number-steps/numberSteps.scss";

const SectionVideoMpc = (props: ReferenciaContenido) => {
    const { 
        tituloGeneral,
        redireccionBoton,
        descripcion,
        imagenPrincipal,
        tituloBoton,
        cambiarDistribucion, 
        selectorDeColor} = props;
    const [isOpenModal, setIsOpenModal] = useState<boolean>(false);

    return (
        <>
            <div className={`o-section-video-mpc ${selectorDeColor.name}`}>
                <div className={`text ${cambiarDistribucion ? "changeDistribution" : ""}`}>
                    {imagenPrincipal &&
                        <img className="text__image" src={imagenPrincipal.file.url}/>
                    }
                    {!tituloBoton && redireccionBoton &&
                        <div className="text__video">
                            <iframe
                                className="video"
                                src={redireccionBoton}
                                allow="picture-in-picture"
                            />
                            <button className="text__video__button" onClick={() => {setIsOpenModal(true)}}></button>
                        </div>
                    }
                    <div className="text__content">
                        <TitleSection title={tituloGeneral} type="h2"/>
                        {descripcion &&
                            documentToReactComponents(descripcion.json)}
                        {tituloBoton && redireccionBoton &&
                            <Button
                                type="link"
                                text={tituloBoton}
                                classname={`a-button__magenta`}
                                isDisabled={false}
                                href={redireccionBoton}
                            />
                        }
                    </div>
                </div>
            </div>
            {isOpenModal && (
                <div className="m-number-steps__modal">
                    <span className="icon-close" onClick={() => setIsOpenModal(false)}></span>
                    <div className="m-number-steps__modal-content">
                        <iframe
                            src={redireccionBoton}
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture">
                        </iframe>  
                    </div>
                </div>
            )}
        </>
    );
};

export default SectionVideoMpc;